'use strict';

const PAYMENT_SYSTEM = {
  STRIPE: 'stripe',
  PAYPAL: 'paypal',
  AMAZON: 'amazon',
  BANK_TRANSFER: 'bank_transfer',
  EPSILON: 'epsilon',
  TMG_ALIPAY: 'tmg_alipay',
  JD: 'jd',
  CRUNCHYROLL: 'crunchyroll',
  CROWDFUNDING: 'crowdfunding',
  SHIPPING_PROXY: 'shipping_proxy', // @deprecated
  SHOPIFY: 'shopify',
  MSS: 'mss',
  BYPASS: 'bypass',
  POINT: 'point',
  NONE: 'none'
};

const PAYMENT_SYSTEM_PATTERN = Object.keys(PAYMENT_SYSTEM).map(
  (key) => PAYMENT_SYSTEM[key]
);

module.exports = {
  PAYMENT_SYSTEM,
  PAYMENT_SYSTEM_PATTERN
};
